module.exports = __webpack_public_path__ + "media/images/area/sub_hero_map_tottori-67c72f9f0fc71a46010137cff979997b.png";